import { render, staticRenderFns } from "./LifeCars.vue?vue&type=template&id=857c0b0a&scoped=true"
import script from "./LifeCars.vue?vue&type=script&lang=js"
export * from "./LifeCars.vue?vue&type=script&lang=js"
import style0 from "./LifeCars.vue?vue&type=style&index=0&id=857c0b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857c0b0a",
  null
  
)

export default component.exports